// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5460a33d","455":"24b1ebd0"}[chunkId] + ".chunk.js";
};